import { createSlice } from "@reduxjs/toolkit";
const initialODSFutureState = { ODSFutureData: {} };

export const ODSFutureSlice = createSlice({
  name: "odsfuture",
  initialState: initialODSFutureState,
  reducers: {
    setODSFutureState(state, action) {
      state.ODSFutureData = {...state.ODSFutureData, ...action.payload };
    },
    resetODSFutureState(state) {
     return initialODSFutureState;
    },
    updateODSFutureState(state, action) {
      state.ODSFutureData = {...state.ODSFutureData, ...action.payload };
    },
  },
});